import { render, staticRenderFns } from "./header.vue?vue&type=template&id=827e9c3a&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"
import style0 from "./header.vue?vue&type=style&index=0&id=827e9c3a&prod&lang=scss"
import style1 from "./header.vue?vue&type=style&index=1&id=827e9c3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "827e9c3a",
  null
  
)

export default component.exports